/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Credit_DebtInputs */

const vi_customer_credit_debt = /** @type {(inputs: Customer_Credit_DebtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính vào công nợ`)
};

/**

* @param {Customer_Credit_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_credit_debt = /** @type {((inputs?: Customer_Credit_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Credit_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_credit_debt(inputs)
});